import React from 'react'
import styled from 'styled-components'
import { Button, Fonts, ModalFromBottom } from 'components/base-ui'
import { useTranslation } from 'react-i18next'

interface Adjustment {
  name: string
  description: string
}

type Props = {
  isOpen: boolean
  adjustment: Adjustment
  onClose: VoidFunction
}

const ModalAutoPromotion = ({ isOpen, adjustment, onClose }: Props) => {
  const { t } = useTranslation()
  const description =
    adjustment.description.length > 0 ? adjustment.description : t('checkout.autoPromotion.defaultDescription')

  return (
    <Modal isOpen={isOpen} hideCloseButton shouldCloseOnOverlayClick={false} btnClose={false} zindex={100}>
      <Wrapper>
        <Fonts.H4>{`${t('checkout.autoPromotion.conditionOf')}${adjustment.name}`}</Fonts.H4>
        <Fonts.Base style={{ overflow: 'scroll' }}>{description}</Fonts.Base>
        <Button onClick={onClose} md>
          {t('checkout.autoPromotion.close')}
        </Button>
      </Wrapper>
    </Modal>
  )
}

export default ModalAutoPromotion

const Modal = styled(ModalFromBottom)`
  height: 266px;
  &:first-child div {
    height: 100%;
  }
`

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`
